import { useEffect } from 'react';
import { loadedAppInsights } from 'services/appInsights/appInsights';
import { useLocation } from 'react-router';

// Minimal page view tracking hook. On path change, send pageView telemetry.
// Skips when AppInsights has not been initialized (tests or missing key).
export const useTrackPage = () => {
  const location = useLocation();

  useEffect(() => {
    // guard: sdk exposes trackPageView on .appInsights core via context.telemetry initialisation
    // We rely on public method from @microsoft/applicationinsights-web: trackPageView.
    const path = location.pathname + (location.search || '');
    try {
      if (typeof loadedAppInsights.trackPageView === 'function') {
        loadedAppInsights.trackPageView({ name: path, uri: path });
      }
    } catch {
      // swallow errors to avoid breaking rendering in tests / offline
    }
  }, [location]);
};
